﻿import { windowMedia } from "../../helpers";
import { Popup, PopupPosition } from "../../utilities/popup";

const initAccountMenu = () =>
{
    if ($(".js-account-menu").length > 0)
    {
        $(".js-account-menu").off();
        $(".js-account-menu").on("click", (e) =>
        {   
            if (windowMedia(768))
            {
                e.preventDefault();
                e.stopPropagation();

                const accountMenuPopup = new Popup({
                    id: "accountmenu",
                    title: "Menu",
                    closeButton: true,
                    content: $(".js-account-menu").find("ul").clone()[0],
                    mobilePosition: PopupPosition.Popup,
                    desktopPosition: PopupPosition.Popup
                });
                accountMenuPopup.show();
            }
        });
    }
}

document.addEventListener("DOMContentLoaded", () =>
{
    initAccountMenu();
});